import './index.less';

import { Checkbox, message } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import shapePng from '@/assets/unsubscribe/Shape.png';
import { useLoginModal } from '@/hooks/useLoginModal';
import { useUserProfile } from '@/hooks/useUserProfile';
import { getSubscribe, updateSubscribe } from '@/services/unsubscribe';

const Unsubscribe = () => {
  const { t: $t } = useTranslation('unsubscribe');
  const { userInfo } = useUserProfile();
  const [hasSubscriptions, setHasSubscriptions] = useState(true);
  const [type, setType] = useState(null);
  const { openLoginModal } = useLoginModal(() => {
    window.location.reload();
  });

  const subscribes = [
    {
      id: $t('unsubsSubscribes0Id'),
      desc: $t('unsubsSubscribes0Desc'),
    },
    {
      id: $t('unsubsSubscribes1Id'),
      desc: $t('unsubsSubscribes1Desc'),
    },
    {
      id: $t('unsubsSubscribes2Id'),
      desc: $t('unsubsSubscribes2Desc'),
    },
    {
      id: $t('unsubsSubscribes3Id'),
      desc: $t('unsubsSubscribes3Desc'),
    },
    {
      id: $t('unsubsSubscribes4Id'),
      desc: $t('unsubsSubscribes4Desc'),
    },
  ];

  const checkSubscribe = () => {
    // 检查是否已退订
    getSubscribe()
      .then((res: any) => {
        const Subscripted = 1;
        const NotSubscripted = 2;
        if (res) {
          if (res?.is_unsubscribe === Subscripted) {
            setHasSubscriptions(true);
          }
          if (res?.is_unsubscribe === NotSubscripted) {
            setHasSubscriptions(false);
          }
        }
      })
      .catch((error) => {
        setType(null);
      });
  };

  useEffect(() => {
    if (userInfo.id) {
      checkSubscribe();
    }
  }, [userInfo]);

  const handleCheck = (current: any, isChecked: boolean) => {
    if (current) {
      setType(isChecked ? current.id : null);
    }
  };

  const usSubmit = () => {
    // 取消退订
    if (type) {
      updateSubscribe({ type: type, platform: 'notification-server' })
        .then((res: any) => {
          if (res?.is_succ === 1) {
            setHasSubscriptions(false);
            message.success($t('unsubsToast'));
          }
        })
        .catch(() => {
          setHasSubscriptions(true);
        });
    }
  };

  return (
    <div>
      <div className={classNames('us-main')}>
        {hasSubscriptions ? (
          <div className={classNames('us-content')}>
            <h1 className={classNames('us-title')} data-paint>
              {$t('unsubsTitle')}
            </h1>
            <ul className={classNames('us-form')}>
              {subscribes.map((option) => (
                <li key={option.id}>
                  <Checkbox
                    className={classNames('unsub-check')}
                    onChange={(e) => {
                      handleCheck(option, e.target.checked);
                    }}
                    checked={type === option.id}
                  >
                    {option.desc}
                  </Checkbox>
                </li>
              ))}
            </ul>
            <div className={classNames('us-submit')}>
              {userInfo.id ? (
                <span
                  className={classNames({ active: !!type })}
                  onClick={usSubmit}
                >
                  {$t('unsubsBtnSubmit')}
                </span>
              ) : (
                <span className={classNames('active')} onClick={openLoginModal}>
                  {$t('unsubsBtnSubmit')}
                </span>
              )}
            </div>
          </div>
        ) : (
          <div
            className={classNames('us-content')}
            style={{ minHeight: 'auto' }}
          >
            <div className={classNames('us-result')}>
              <img src={shapePng} alt="" />
              <div className={classNames('us-result-content')}>
                <h1 className={classNames('us-result-title')}>
                  {$t('unsubsResultTitle')}
                </h1>
                <p className={classNames('us-result-desc')}>
                  {$t('unsubsResultDesc')}
                </p>
              </div>
            </div>
            <div
              className={classNames('us-submit')}
              style={{ marginLeft: '63px' }}
            >
              <a href="/" className={classNames('active')}>
                {$t('unsubsBtnGoHome')}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
